import classes from './Item.module.css'

const ItemSimple = ({children}) => {
    return <div className={`${classes.item}`}>
        <div>
            {children}
        </div>
    </div>
}

export default ItemSimple